import { useSyncExternalStore } from 'react';

export const PAGE_SIZE_OPTIONS = [10, 20, 50];

const STORAGE_KEY = 'delegon_pageSize';
const listeners = new Set();

const readStoredPageSize = () => {
  try {
    const value = Number(window.localStorage.getItem(STORAGE_KEY));
    return PAGE_SIZE_OPTIONS.includes(value) ? value : PAGE_SIZE_OPTIONS[0];
  } catch {
    return PAGE_SIZE_OPTIONS[0];
  }
};

let pageSize = readStoredPageSize();

const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

const getPageSize = () => pageSize;

export const setPageSize = (value) => {
  if (!PAGE_SIZE_OPTIONS.includes(value) || value === pageSize) return;
  pageSize = value;
  try {
    window.localStorage.setItem(STORAGE_KEY, String(value));
  } catch {}
  listeners.forEach((listener) => listener());
};

export const usePageSize = () => [useSyncExternalStore(subscribe, getPageSize), setPageSize];
